import mod from "-!./smetaTab.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./smetaTab.js?vue&type=script&lang=js&external"